module.exports = __webpack_public_path__ + "img/Sylva_round.cf30573c.png";